import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Typography,
  Grid,
  Button,
  MenuItem,
} from '@mui/material';
import './CreateAccount.css';

const CreateAccount = () => {
  const [form, setForm] = useState({
    fullName: '',
    mobile: '',
    email: '',
    pan: '',
    aadhaar: '',
    dob: '',
    businessName: '',
    entityType: '',
    gst: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    bankName: '',
    accountName: '',
    accountNumber: '',
    ifsc: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    console.log('DSA Data Submitted:', form);
    // TODO: call backend API and upload data
  };

  return (
    <Container maxWidth="md">
      <Paper className="create-card">
        <Typography variant="h5" className="create-title">
          DSA Registration – Create Account
        </Typography>

        <Typography className="section-label">🧾 Basic Details</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField name="fullName" label="Full Name" value={form.fullName} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="mobile" label="Mobile Number" value={form.mobile} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="email" label="Email Address" value={form.email} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="dob" label="Date of Birth" type="date" InputLabelProps={{ shrink: true }} value={form.dob} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="pan" label="PAN Number" value={form.pan} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="aadhaar" label="Aadhaar Number" value={form.aadhaar} onChange={handleChange} fullWidth />
          </Grid>
        </Grid>

        <Typography className="section-label">🏢 Business Info</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField name="businessName" label="Business/Firm Name" value={form.businessName} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="entityType" label="Entity Type" select value={form.entityType} onChange={handleChange} fullWidth>
              <MenuItem value="proprietor">Proprietor</MenuItem>
              <MenuItem value="partnership">Partnership</MenuItem>
              <MenuItem value="pvtltd">Private Ltd</MenuItem>
              <MenuItem value="llp">LLP</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField name="gst" label="GST Number (optional)" value={form.gst} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <TextField name="address" label="Business Address" value={form.address} onChange={handleChange} fullWidth multiline rows={2} />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField name="city" label="City" value={form.city} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField name="state" label="State" value={form.state} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField name="pincode" label="Pincode" value={form.pincode} onChange={handleChange} fullWidth />
          </Grid>
        </Grid>

        <Typography className="section-label">🏦 Bank Details</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField name="bankName" label="Bank Name" value={form.bankName} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="accountName" label="Account Holder Name" value={form.accountName} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="accountNumber" label="Account Number" value={form.accountNumber} onChange={handleChange} fullWidth />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField name="ifsc" label="IFSC Code" value={form.ifsc} onChange={handleChange} fullWidth />
          </Grid>
        </Grid>

        <Button variant="contained" fullWidth className="submit-button" onClick={handleSubmit}>
          Submit Account Info
        </Button>
      </Paper>
    </Container>
  );
};

export default CreateAccount;